/**
 * Window event carrying a message for the header's mini-cart live region
 * (CPS-7696), so the island can announce its errors without sharing state
 * with the header, which owns the region.
 */
export const MINI_CART_ANNOUNCEMENT_EVENT = 'compass:mini-cart-announcement';

type MiniCartAnnouncementDetail = { message: string };

/** Announces `message` politely through the header's live region. */
export const announceMiniCart = (message: string): void => {
  window.dispatchEvent(
    new CustomEvent<MiniCartAnnouncementDetail>(MINI_CART_ANNOUNCEMENT_EVENT, {
      detail: { message },
    })
  );
};

/** The header subscribes here; returns the unsubscribe for an effect cleanup. */
export const subscribeToMiniCartAnnouncements = (
  listener: (message: string) => void
): (() => void) => {
  const onAnnouncement = (event: Event) =>
    listener((event as CustomEvent<MiniCartAnnouncementDetail>).detail.message);
  window.addEventListener(MINI_CART_ANNOUNCEMENT_EVENT, onAnnouncement);
  return () =>
    window.removeEventListener(MINI_CART_ANNOUNCEMENT_EVENT, onAnnouncement);
};
